/** Payload `data` dell'envelope Kairos per GET features/nps. */
export type NpsEligibilityPayload = {
  userId?: string;
  workspace?: string;
  realm?: string;
  questionnaireToShow?: string | null;
  outcome?: string | null;
  reason?: string | null;
};

/**
 * Corpo della risposta HTTP (axios `response.data`).
 * Allineato alle altre API portal (es. FAQ: `response.data.data`).
 */
export function extractNpsEligibilityPayload(
  body: unknown,
): NpsEligibilityPayload | null {
  if (body === null || body === undefined || typeof body !== 'object') {
    return null;
  }
  const root = body as Record<string, unknown>;
  const inner = root.data;
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
    const d = inner as Record<string, unknown>;
    if (
      'questionnaireToShow' in d ||
      'userId' in d ||
      'workspace' in d ||
      'realm' in d ||
      'outcome' in d ||
      'reason' in d
    ) {
      return d as NpsEligibilityPayload;
    }
    const nested = d.data;
    if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
      return nested as NpsEligibilityPayload;
    }
  }
  return null;
}

export function shouldShowNpsQuestionnaire(
  payload: NpsEligibilityPayload | null,
): boolean {
  if (!payload) {
    return false;
  }
  const id = payload.questionnaireToShow;
  if (id === null || id === undefined) {
    return false;
  }
  return typeof id === 'string' && id.trim().length > 0;
}
